import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: 40,
  height: 600,
  overflow: 'hidden'
});
export const button = css({
  minHeight: '60px'
});
